angular.module('impactx.product').factory('ProductFactory', [
    '$q',
    '$sce',
    'dataGen',
    'searchFilter',
    'FavoritesService',
    'productComparison',
    'AddToBasketService',
    'ToolbarService',
    function ($q, $sce, dataGen, searchFilter, FavoritesService, productComparison, AddToBasketService, ToolbarService) {
        return {
            /**
             * Creates new product data object based on given parameters
             * @param id ID of the product
             * @param preConfigured information about pre-configuration
             * @param oldBKIId ID of the old basket item
             * @param patIds possible set pat ids for configuration
             * @param vCatId ID of the view the product was opened from
             * @returns {ProductData} new object to operate with product data
             */
            new: function (id, preConfigured, oldBKIId, patIds, isUnite, catId, vCatId) {
                return new ProductData($q, $sce, dataGen, id, searchFilter, preConfigured, FavoritesService, productComparison, AddToBasketService, oldBKIId, ToolbarService, patIds, isUnite, catId, vCatId);
            }
        }
    }]);

function ProductData($q, $sce, dataGen, id, searchFilter, preConfigured, FavoritesService, productComparison, AddToBasketService, oldBKIId, ToolbarService, patIds, isUnite, catId, vCatId) {
    var vm = this;

    vm.model = {};

    vm.model.config = {};

    vm.model.product = {};

    vm.model.printTokens = {};

    vm.model.product.id = id;

    vm.model.currentPage = 0;

    vm.model.scrollList = [];

    vm.addToFavorites = function () {
        FavoritesService.add(vm.model.product);
    };

    vm.removeFromFavorites = function () {
        FavoritesService.remove(vm.model.product);
    };

    vm.addToComparison = function () {
        if (isUnite) {
            productComparison.addExternalProductToComparison(vm.model.product);
        } else {
            productComparison.addToComparison(vm.model.product.id);
        }
    };

    vm.replaceInBasket = function (actionTrns) {
        if (oldBKIId > 0) {
            AddToBasketService.replaceInBasket(vm.model.product.id, oldBKIId, actionTrns);
        }
    };

    vm.addFreeform = function () {
        AddToBasketService.addFreeform(vm.model.product);
    };

    vm.addExternalProductToBasket = function (event, amount) {
        var product = vm.model.product;
        var trustedDescription = product.description;
        product.description = product.descriptionNonTrusted;
        AddToBasketService.addExternalProductToBasket(event, product, amount).finally(function () {
            product.description = trustedDescription;
        });
    };


    vm.check = function () {
        var configuration = {};
        for (var i = 0; i < vm.model.config.drillDowns.length; i++) {
            if (vm.model.config.drillDowns[i] && !vm.model.config.drillDowns[i].available) {
                var fv = vm.model.config.drillDowns[i];
                vm.model.config.drillDowns.length = 0;
                vm.model.config.drillDowns[i] = fv;
            }
        }
        configuration.drillDowns = vm.model.config.drillDowns;
        configuration.currentPro = vm.model.product.id;
        var scope2 = {};
        return dataGen.postAsForm(scope2, {configuration: configuration}, "/product/config/check").then(function () {
            vm.model.config = scope2.data;
            vm.getProductData(vm.model.config.currentPro, vm.model.config.fullyConfigured);
        });
    };

    vm.selectProduct = function (add) {
        vm.model.currentPage = vm.model.currentPage + add;
        if (vm.model.currentPage < 0) {
            vm.model.currentPage = 0;
        }
        else if (vm.model.currentPage > vm.model.config.proIds.length - 1) {
            vm.model.currentPage = vm.model.config.proIds.length - 1;
        }
        return vm.getProductData(vm.model.config.proIds[vm.model.currentPage], function () {
        });
    };

    vm.selectConfig = function (imageConfig) {
        vm.model.config.drillDowns.splice(0, vm.model.config.drillDowns.length);
        angular.forEach(imageConfig.drillDowns, function (value, key) {
            vm.model.config.drillDowns.push(value);
        });
    };

    vm.getProductData = function (id, fullyConfigured) {
        if (!id) {
            id = vm.model.product.id;
        }
        var scope2 = {};
        var endpoint = isUnite ? "/product/unite/view" : "/product/view";
        var params = {
            id: id,
            oldBKIId: oldBKIId ? oldBKIId : 0,
            fullyConfigured: fullyConfigured ? fullyConfigured : false
        };
        if (isUnite && catId) {
            params.catId = catId;
        }
        if (vCatId) {
            params.vCatId = vCatId;
        }
        return dataGen.getData(scope2, params, endpoint).then(function () {
            vm.model.hasActiveFilter = hasActiveFilter();
            vm.model.product = scope2.data;
            vm.model.printTokens = scope2.printTokens;
            vm.model.trns = scope2.trns;
            vm.model.product.descriptionNonTrusted = scope2.data.description;
            vm.model.product.description = $sce.trustAsHtml(scope2.data.description);
            vm.createScrollList(vm.model.product);
        });
    };

    vm.getConfiguration = function () {
        if (vm.model.product.isConfigProduct && !vm.model.product.isDeprecated) {
            var $scope2 = {};
            return dataGen.getData($scope2, {
                id: vm.model.product.id,
                preConfigured: preConfigured,
                patIds: patIds
            }, "/product/config/get").then(function () {
                vm.model.config = $scope2.data;
                var needsCheck = false;
                if (!vm.model.config.drillDowns) {
                    vm.model.config.drillDowns = [];
                }
                else {
                    needsCheck = true;
                }
                var drilldowns = searchFilter.getSearchFilterData().drillDowns;
                angular.forEach(drilldowns, function (value, key) {
                    angular.forEach(vm.model.config.facetResults, function (value2, key2) {
                        if (value.patId == value2.id) {
                            angular.forEach(value2.displayOptions, function (value3, key3) {

                                if (value.label == value3.label) {
                                    vm.model.config.drillDowns[key2] = value3;
                                    needsCheck = true;
                                }
                            });
                        }
                    });
                });
                if (needsCheck) {
                    vm.check();
                }
            });
        }
        return $q.when();
    };

    vm.createScrollList = function (product) {

        //this prevents IOBL-367
        var tempScrollList = [];

        if (product.referenceProducts) {
            var numberOfReferences = product.referenceProducts.length;
            if (numberOfReferences > 1) {
                tempScrollList.push({
                    id: "references",
                    label: numberOfReferences + " " + vm.model.trns.references
                })
            }
            if (numberOfReferences == 1) {
                tempScrollList.push({
                    id: "references",
                    label: numberOfReferences + " " + vm.model.trns.references
                })
            }
        }
        if (tempScrollList.length > 0) {
            tempScrollList.unshift({id: "header", label: vm.model.trns.headerData});
        }

        vm.model.scrollList = tempScrollList;
        ToolbarService.setScrollMenu(vm.model.scrollList)
    };

    function hasActiveFilter() {
        var searchFilterData = searchFilter.getSearchFilterData();
        return !!((searchFilterData.tenderId && searchFilterData.tenderId.value) ||
            (searchFilterData.lotId && searchFilterData.lotId.value) ||
            (searchFilterData.vcatalogId && searchFilterData.vcatalogId.value) ||
            (searchFilterData.supplierId && searchFilterData.supplierId.value) ||
            (searchFilterData.manufacturerId && searchFilterData.manufacturerId.value));
    }
}